"use client";

import { ArrowRight, Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function InvisibleClimate() {
  const stats = [{
    label: "ENERGIEEFFIZIENZ",
    value: "A++"
  }, {
    label: "INSTALLATION",
    value: "DACHBODEN"
  }, {
    label: "EWÄRMEG BW",
    value: "KONFORM"
  }];
  const recommendations = [{
    text: "Einfamilienhäuser & Reihenhäuser (oberstes Geschoss)"
  }, {
    text: "Dachgeschosswohnungen ohne Wandplatz"
  }, {
    text: "Räume mit besonders hohen Decken"
  }];
  return <section data-section-id="2534" id="technik-die-man-nicht-sieht" className="bg-white text-black relative overflow-hidden pt-24 pb-24 md:pt-32 md:pb-32 border-b border-black/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 mb-12 md:mb-16">
        {}
      </div>

      <div className="relative w-full h-auto overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/Das Ducted AC System.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/Das Ducted AC System.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/Das Ducted AC System.png-wvc-sizes" alt="InvisibleClimate system installation overview" loading="eager" className="w-full h-full object-contain block" />
      </div>

      <div className="h-[9.5rem] w-full bg-white"></div>

      <div className="mt-0 flex flex-col justify-center px-6 md:px-12 lg:px-16 bg-black/5 py-8 md:py-12 lg:py-16">
        <div className="max-w-[1400px] mx-auto w-full">
          <h1 className="font-sans font-bold text-[clamp(2rem,6vw,5.5rem)] leading-[1.0] tracking-tighter mb-6 md:mb-10 text-black">
            DIE <span className="font-light italic text-black/30" style={{
            WebkitTextStroke: '1px rgba(0,0,0,0.5)'
          }}>UNSICHTBARE</span>
            <br />
            KLIMATISIERUNG
          </h1>
          <p className="font-sans text-black/80 text-base md:text-xl leading-relaxed max-w-xl mb-8">
            Sie wünschen sich ein perfekt temperiertes Zuhause ohne klobige Geräte an der Wand? Unser Ducted AC System wird diskret auf dem Dachboden installiert und sorgt über flache Deckenventile für flüsterleise, zugfreie Kühlung und effiziente Wärme.
          </p>
          <div className="h-px w-full bg-black/5"></div>
        </div>
      </div>

      <div className="absolute top-8 left-6 md:left-12 font-mono text-[10px] tracking-[0.2em] text-black/40">
        [ 01 ]
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          
          <div className="lg:col-span-7 flex flex-col">
            <div className="font-mono text-[0.75rem] tracking-[0.2em] text-[#0099cc] uppercase mb-6 flex items-center gap-4">
              <span className="h-px w-8 bg-[#0099cc]"></span>
              DUCTED AC SYSTEM / 2025
            </div>

            <div className="max-w-xl space-y-8">
              <div className="flex flex-col sm:flex-row sm:items-center gap-8">
                <Button asChild size="lg" className="bg-[#0099cc] text-white hover:bg-[#0099cc]/90 font-mono uppercase tracking-widest text-xs px-10 h-14 rounded-lg transition-transform hover:translate-x-2">
                  <Link to="/SolutionPage">
                    LÖSUNG ENTDECKEN
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Link>
                </Button>

                <Link to="/LegalPage" className="font-mono uppercase tracking-widest text-[10px] text-black/50 hover:text-[#0099cc] transition-colors flex items-center gap-2 group">
                  GESETZLICHE VORGABEN
                  <span className="h-px w-4 bg-black/30 group-hover:bg-[#0099cc] transition-colors"></span>
                </Link>
              </div>
            </div>

            <div className="mt-20 grid grid-cols-1 md:grid-cols-3 border border-black/10">
              {stats.map((stat, i) => <div key={i} data-index={i} className="p-8 border-b md:border-b-0 md:border-r border-black/10 last:border-r-0 relative group">
                  <Plus className="absolute top-0 left-0 -translate-x-1/2 -translate-y-1/2 size-3 text-[#0099cc] opacity-0 group-hover:opacity-100 transition-opacity" />
                  <div className="font-mono text-[10px] tracking-widest text-black/40 mb-2">{stat.label}</div>
                  <div className="text-2xl font-bold tracking-tight text-[#0099cc]">{stat.value}</div>
                </div>)}
            </div>
          </div>

          <div className="lg:col-span-5 relative lg:-mt-80 xl:-mt-96">
            <div className="relative border border-black/10 p-0 rounded-lg bg-white">
              <div className="absolute -right-8 top-1/2 -rotate-90 origin-center font-mono text-[9px] tracking-[0.3em] text-black/20 whitespace-nowrap">
                TEMP_CONTROL // 21.5°C // FLOW_ACTIVE
              </div>

              <div className="relative aspect-[4/5] overflow-hidden rounded-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/ducted_ac_modern_interior.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/ducted_ac_modern_interior.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/ducted_ac_modern_interior.webp-wvc-sizes" alt="Modernes Wohnzimmer mit unsichtbarer Klimatisierung" loading="lazy" decoding="async" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700 scale-105 hover:scale-100" />
                
                <div className="absolute top-8 right-8 flex flex-col gap-2 items-end">
                  <div className="h-px w-12 bg-[#0099cc]"></div>
                  <div className="h-px w-8 bg-[#0099cc]/60"></div>
                  <div className="h-px w-16 bg-[#0099cc]/30"></div>
                </div>
              </div>
            </div>

            <div className="mt-4 space-y-6">
              <h3 className="font-sans font-semibold text-xl tracking-tight text-black">Einsatzbereiche</h3>
              <ul className="space-y-4">
                {recommendations.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-4 group">
                    <span className="mt-2 size-1.5 bg-[#0099cc] rounded-lg group-hover:scale-150 transition-transform"></span>
                    <span className="text-black/60 text-sm font-sans leading-tight">{item.text}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-16 border-t border-black/10 grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div className="space-y-8">
            <p className="text-black/70 text-lg leading-relaxed font-sans">
              Da die Räume über eine zentrale Inneneinheit versorgt werden, werden sie gleichmäßig klimatisiert. Eine Feinjustierung der Luftmenge pro Raum kann optional über eine manuelle Klappensteuerung vorgenommen werden.
            </p>
            <p className="text-black/70 text-lg leading-relaxed font-sans">
              Bei stark abweichenden Raumgrößen oder getrennten Wohnbereichen kombinieren wir einfach zwei separate Kanalgeräte, die völlig unabhängig voneinander regelbar sind.
            </p>
          </div>
          <div className="bg-black/5 p-10 border border-black/10 rounded-lg relative overflow-hidden">
            <div className="absolute top-0 right-0 p-4 font-mono text-[8px] text-black/20">SYSTEM_SPEC_V2</div>
            <p className="text-black text-xl leading-relaxed font-bold font-sans relative z-10">
              Ergebnis: Keine klobigen Wand- oder Truhengeräte. Sichtbar ist pro Raum lediglich ein einziges, elegantes Deckenventil (100–250 mm). Die elegante und effektive Lösung für ein komfortables Raumklima.
            </p>
            <div className="mt-8 flex items-center gap-2">
              <div className="size-2 bg-[#0099cc] rounded-lg"></div>
              <div className="h-px flex-1 bg-black/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}